export enum AppFeatureEnum {
    CargoConsumable = 1,
    CargoTemperatureControlLog = 2,
    PbiReports = 3,
    Verification = 4,
    Notifications = 5,
    CargoTempControlSection = 6,
    SmReports = 7,
    Stowage = 8,
    Bunkering = 9,
    StowageCargoTemperaturePerTank = 10,
    StowageIntegration = 11,
    CargoTempLogQuestionnaire = 27,
}
